import { DraftProps } from 'app/area/case/draft/types';

const newCaseSpecificTexts = {
  case_confirmation_title: 7457,
  case_confirmation_description: 7456,
  case_confirmation_continue: 7455,
  case_confirmation_cancel: 7454,
  submit: 7448,
  cancel: 3273
};

const existingCaseSpecificTexts = {
 case_confirmation_title: 7461,
 case_confirmation_description: 7460,
 case_confirmation_continue: 5792,
 case_confirmation_cancel: 7454,
 submit: 7497,
 cancel: 7498
};

const connectedCaseOverrides = {
  submit: 7724
};

export const draftTranslations = (props: DraftProps) => ({  
  case_saving: 7449,
  draft_saving: 7450,
  draft_not_changed: 7452,
  unsaved_changes: 7451,
  overlay_text_saving_case: 7453,
  really_exit: 7552,
  you_are_connecting_a_new_case: 7723,
  case_menu: 7969,
  switch_to_tab: 7978,
  switch_to_scroll: 7977,
  warning_dialog_title: 8325,
  warning_dialog_description: 8326,
  warning_dialog_submit: 8327,
  warning_dialog_cancel: 8328,
  save_as_draft: 9759,
  overlay_text_saving_as_draft: 9923,
  ...( props.caseNumber ? existingCaseSpecificTexts : newCaseSpecificTexts ),
  ...( props.connectToDraft && props.connectToDraft.length ? connectedCaseOverrides : {})
});
